export default "__VITE_ASSET__wlMqeK$F__"